module.exports = __webpack_public_path__ + "static/media/red_time_written.3644eb47.svg";